import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { HashLoader } from "react-spinners";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

import ArrowBack from '@material-ui/icons/ArrowBack';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Tooltip from '@material-ui/core/Tooltip';

import { AppState } from '../../store';
import { UsersState } from '../../store/users/types';
import { RolesState } from '../../store/roles/types';
import { loadExternalRoles, selectGroup } from '../../store/roles/actions';
import {
    loadUsers,
    updateUserField,
    saveExternalUser,
    emptyUser,
    selectNoRoles,
    selectAllRoles,
    selectAllRolesInGroup,
    selectNoRolesInGroup,
    addRole,
    removeRole,
    loadExternalUserById,
    resetPassword,
    loadOptions,
    companyForType,
    resetExternalRoles
} from '../../store/users/actions';

import AppHeader from '../../components/header/header';
import StickySaveBar from '../../components/stickySaveBar/stickySaveBar';


const ACCOUNT_TYPES = ['Affiliate', 'Client', 'Vendor']

const spinnerStyle = `
    margin: 100px auto;
`

const companies = {
    'ta': 'Traders Agency',
    'lm': 'LeadMark',
    'tg': 'TrafficGrid'
}



function RoleSelect({ self, role }) {
    return <li onClick={() => self.switchRole(role)} key={`role_${role.GroupName}`}>
        <label onClick={e => e.preventDefault()} className="checkbox">
            <input onClick={e => e.preventDefault()} type="checkbox" checked={self.userHasRole(role.GroupName)} />
            <span className="checkmark"></span>
        </label>
        {role.prettyName}
    </li>
}

function OffersSelect({ self, company, role }) {
    return <>
        <label style={{ textTransform: 'capitalize' }}>{companies[company]} Offers List</label>
        <Autocomplete
            options={self.props.users!.offersOptions![company] || []}
            getOptionLabel={(option) => option.label}
            multiple
            autoHighlight
            size="small"
            disableCloseOnSelect
            renderOption={(option, { selected }) => (
                <React.Fragment>
                    <Checkbox
                        style={{ marginRight: 4 }}
                        checked={selected}
                    />
                    {option.label}
                </React.Fragment>
            )}
            renderInput={(params) => <TextField {...params} variant="outlined" />}
            onChange={(event: any, newValue: any) => {
                if (newValue.length * self.getOffers(company).length === 0) { // check whether current or previous length was 0
                    self.setRole(role, newValue.length > 0);
                };
                self.handleCustomOfferType(newValue, company);
            }}
            value={self.getOffers(company)}
        />
        {self.state.error && self.state.error['offer-' + company] && <span style={{ color: 'red' }}>{self.state.error['offer-' + company]}</span>}
    </>
}


interface UserInterfaceProps {
    users: UsersState
    roles: RolesState
    loadUsers: Function
    updateUserField: Function
    saveExternalUser: Function
    emptyUser: Function
    loadExternalRoles: Function
    selectGroup: Function
    addRole: Function
    removeRole: Function
    selectAllRoles: Function
    selectNoRoles: Function
    selectAllRolesInGroup: Function
    selectNoRolesInGroup: Function
    loadExternalUserById: Function
    resetPassword: Function
    loadOptions: Function,
    resetRoles: Function,
    match: {
        params: {
            id: number
        }
    },
    history: any
}

class UserEditExternal extends React.Component<UserInterfaceProps> {
    state = {
        error: undefined
    };
    public componentDidMount(): void {
        this.props.loadExternalRoles();
        if (this.props.match.params.id) {
            this.props.loadExternalUserById(this.props.match.params.id);
        } else {
            this.props.emptyUser();
        }
    }

    private handleChange(field: string, value: any): void {
        const user = this.props.users.editedUser;
        if (!user) { return; }
        switch (field) {
            case 'account_type':
                const acc_type = value.value;
                this.props.updateUserField(field, acc_type);
                this.props.resetRoles(user?.Username, user["cognito:groups"]);
                let acc_types = { type: acc_type, companies: {} };

                this.props.updateUserField('custom:account_type', acc_types);
                this.props.loadOptions(companyForType[acc_type], value.value);

                break;

            default:
                this.props.updateUserField(field, value);
        }
    }

    private handleCustomAccountType(value: any, company: string) {
        if (value.length > 10) {
            this.setState({ error: { ['affiliate-' + company]: 'Too many items. Max is 10.' } });
            return;
        }
        if (this.state.error && this.state.error!['offer-' + company]) {
            this.setState({ error: undefined });
        }
        const user = this.props.users.editedUser;
        if (user) {
            let acc_type = user['custom:account_type'] || { type: user.account_type, companies: {}, ...(user.account_type === 'Affiliate' ? { offers: {} } : {}) };
            if (!acc_type.companies) {
                acc_type = { type: user.account_type, companies: {} }
            }
            acc_type.companies[company] = value.map(e => e.value);
            if (value.length === 0 && user.account_type === 'Affiliate' && acc_type.offers) {
                delete acc_type.offers[company]
            }

            this.props.updateUserField('custom:account_type', acc_type);
        }
    }
    private handleCustomOfferType(value: any, company: string) {
        if (value.length > 10) {
            this.setState({ error: { ['offer-' + company]: 'Too many items. Max is 10.' } });
            return;
        }
        if (this.state.error && this.state.error!['offer-' + company]) {
            this.setState({ error: undefined });
        }
        const user = this.props.users.editedUser;
        if (user) {
            let acc_type = user['custom:account_type'] || { type: user.account_type, companies: {}, offers: {} };
            if (!acc_type.offers) {
                acc_type.offers = {};
            }
            acc_type.offers[company] = value.map(e => e.value);

            this.props.updateUserField('custom:account_type', acc_type);
        }
    }

    private getAccountValue() {
        const values = {};
        Object.keys(companies).forEach(company => {
            values[company] = [];
            if (this.props.users.editedUser && this.props.users.accountTypeOptions[company]) {
                const value = this.props.users.editedUser['custom:account_type'];
                if (value) {
                    const idsList = value.companies ? (value.companies[company] || []) : [];
                    let result: Array<any> = [];
                    for (let itm of this.props.users.accountTypeOptions[company]) {
                        if (idsList.includes(itm.value)) {
                            result.push(itm);
                        }
                    }
                    values[company] = result
                }
            }
        })
        return values;
    }

    private getOffers(company: string) {
        const values: any[] = []
        if (this.props.users.editedUser && this.props.users.offersOptions && this.props.users.offersOptions[company]) {
            const value = this.props.users.editedUser['custom:account_type'];
            if (value) {
                const idsList = value.offers ? (value.offers[company] || []) : [];
                for (let itm of this.props.users.offersOptions[company]) {
                    if (idsList.includes(itm.value)) {
                        values.push(itm);
                    }
                }
            }
        }
        return values;
    }

    private handleSubmit(event): void {
        event.preventDefault();
        const user = this.props.users.editedUser;
        this.props.saveExternalUser(user, this.props.history);
    }

    // private remove(id: any): void {
    //     if(window.confirm('Are you sure you want to delete the Offer?') )
    //         this.props.removeOffer(id, this.props.history);
    // } 

    private userHasRole(role): boolean {
        let user = this.props.users.editedUser;
        if (user !== null && user['cognito:groups']) {
            return user['cognito:groups'].find(userRole => userRole.GroupName === role) !== undefined;
        }
        return false
    }

    private resetPassword(e) {
        e.preventDefault();
        this.props.resetPassword(this.props.users.editedUser?.email);
    }

    public getRolesInGroupCount(group): number {
        let count = 0;
        if (this.props.users.editedUser) {
            this.props.users.editedUser['cognito:groups'].forEach(role => {
                if (group.find(group => group.GroupName === role.GroupName)) {
                    count++;
                }
            })
        }
        return count
    }

    public switchRole(group): void {
        let currentUser = this.props.users.editedUser;
        if (currentUser) {
            let found = currentUser['cognito:groups'].find(itm => itm.GroupName === group.GroupName)
            if (found) {
                this.props.removeRole(currentUser.Username, group);
            } else {
                this.props.addRole(currentUser.Username, group);
            }
        }
    }
    public setRole(group, newValue): void {
        let currentUser = this.props.users.editedUser;
        if (currentUser) {
            if (newValue) {
                this.props.addRole(currentUser.Username, group);
            } else {
                this.props.removeRole(currentUser.Username, group);
            }
        }
    }


    public filter(keyList: string[]): string[] {
        const ac = this.props.users.editedUser ? this.props.users.editedUser['custom:account_type'] : undefined;
        if (!ac) {
            return [];
        }
        const { type, companies } = ac;
        if (!type) {
            return []
        }
        let typeFiltered = keyList.filter(k => k.includes(type.toLowerCase()));

        return typeFiltered.filter(role => {
            return Object.keys(companies).some(c => role.toLowerCase().includes(c) && companies[c].length > 0);
        })
    }


    public render(): JSX.Element {
        const accountValue: any = this.getAccountValue()

        return (
            <div>
                <AppHeader>
                    <Button onClick={() => document.location.href = '/'} style={{ marginLeft: '10px' }}>
                        <ArrowBack style={{ color: 'var(--color3)' }} />
                    </Button>
                </AppHeader>
                <HashLoader
                    css={spinnerStyle}
                    size={100}
                    color={"#297DAC"}
                    loading={this.props.users.loadingUser} />
                {!this.props.users.loadingUser && this.props.users.editedUser !== null ?

                    <form className="sections__form" onSubmit={this.handleSubmit.bind(this)}>
                        <StickySaveBar />
                        <section style={{
                            padding: '20px 20px 20px'
                        }}>
                            <div className="page__title">
                                <h1 className="section__name" style={{ padding: '0 0 10px 0' }}>Basic Information</h1>

                            </div>

                            <HashLoader
                                css={spinnerStyle}
                                size={100}
                                color={"#297DAC"}
                                loading={this.props.users.loadingUser} />


                            {!this.props.users.loadingUser && this.props.users.editedUser !== null ?
                                <div>
                                    <div className="flexBox">
                                        <div>
                                            <label>Email</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser.email} onChange={event => this.handleChange('email', event.target.value)} />
                                            </div>
                                        </div>

                                        <div>
                                            <label>Phone Number</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser.phone_number} onChange={event => this.handleChange('phone_number', event.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div style={{ display: 'flex' }}>
                                        {this.props.users.editedUser.Username && (
                                            <button className="button white" style={{ padding: '0 36px' }} onClick={(e) => this.resetPassword(e)}>Reset Password</button>
                                        )}
                                        <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                            <label>User is Active?</label>
                                            <div className="checkbox">
                                                <input
                                                    onChange={() => null}
                                                    type="checkbox"
                                                    checked={this.props.users.editedUser.Enabled}
                                                />
                                                <span className="checkmark" onClick={() => this.handleChange('Enabled', !this.props.users.editedUser?.Enabled)}></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </section>


                        <section style={{
                            padding: '20px 20px 20px'
                        }}>
                            <div className="page__title">
                                <h1 className="section__name" style={{ padding: '0 0 10px 0' }}>Account Type</h1>

                            </div>

                            <HashLoader
                                css={spinnerStyle}
                                size={100}
                                color={"#297DAC"}
                                loading={this.props.users.loadingUser || this.props.users.loadingOptions} />


                            {!this.props.users.loadingUser && !this.props.users.loadingOptions && this.props.users.editedUser !== null ?
                                <div>
                                    <div className="flexBox">
                                        <div>
                                            <Tooltip title="An external user can be of one type only" arrow placement="top">
                                                <label>Account Type</label>
                                            </Tooltip>


                                            <div>
                                                <Dropdown
                                                    options={ACCOUNT_TYPES}
                                                    onChange={type => this.handleChange('account_type', type)}
                                                    value={this.props.users.editedUser.account_type}
                                                    placeholder="Select account type"
                                                />
                                            </div>
                                        </div>
                                        {this.props.users.editedUser.account_type ?

                                            companyForType[this.props.users.editedUser?.account_type].map(company =>
                                                <div key={company}>
                                                    <label style={{ textTransform: 'capitalize' }}>{companies[company]} {this.props.users.editedUser?.account_type} List</label>
                                                    <Autocomplete
                                                        id="account_type_options_dropdown"
                                                        options={this.props.users.accountTypeOptions[company] || []}
                                                        getOptionLabel={(option) => option.label}

                                                        multiple
                                                        autoHighlight
                                                        size="small"
                                                        disableCloseOnSelect
                                                        renderOption={(option, { selected }) => (
                                                            <React.Fragment>
                                                                <Checkbox
                                                                    style={{ marginRight: 4 }}
                                                                    checked={selected}
                                                                />
                                                                {option.label}
                                                            </React.Fragment>
                                                        )}
                                                        renderInput={(params) => <TextField {...params} variant="outlined" />}
                                                        onChange={(event: any, newValue: any) => {
                                                            this.handleCustomAccountType(newValue, company);
                                                        }}
                                                        value={accountValue[company]}
                                                    />
                                                    {this.state.error && this.state.error!['affiliate-' + company] && <span style={{ color: 'red' }}>{this.state.error!['affiliate-' + company]}</span>}
                                                </div>

                                            ) : null

                                        }
                                    </div>
                                </div>
                                : null}
                        </section>

                        {this.props.users.editedUser.Username && (
                            <section style={{
                                padding: '20px 20px 20px'
                            }}>
                                <div className="page__title">
                                    <h1 className="section__name" style={{ padding: '0 0 10px 0' }}>Roles</h1>
                                </div>

                                <HashLoader
                                    css={spinnerStyle}
                                    size={100}
                                    color={"#297DAC"}
                                    loading={this.props.users.loadingUser} />
                                {!this.props.users.loadingUser ?

                                    <div className={'roles-manager'}>
                                        <div className={'list'}>
                                            <ul style={{
                                                marginTop: '10px',
                                                maxHeight: '500px',
                                                overflowY: 'auto',
                                                overflowX: 'hidden',
                                                paddingRight: '10px'
                                            }}>
                                                {this.filter(Object.keys(this.props.roles.rolesGrouped)).map(key =>
                                                    <li className={`${this.props.roles.selectedGroupName === key ? 'active' : ''}`} onClick={() => this.props.selectGroup(this.props.roles.rolesGrouped[key], key)} key={`group_${key}`}>
                                                        {key}
                                                        <span style={{ color: '#000', fontSize: '14px', float: 'right' }}>{this.getRolesInGroupCount(this.props.roles.rolesGrouped[key])}/{this.props.roles.rolesGrouped[key].length}</span>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>

                                        <div className={'details'}>
                                            {this.props.roles.selectedGroup !== null && (
                                                this.props.roles.selectedGroupName === 'affiliate LM media buys' ?
                                                    <>
                                                        <h4 style={{ marginTop: 0, textTransform: 'capitalize' }}>
                                                            {this.props.roles.selectedGroupName}
                                                        </h4>
                                                        <ul>
                                                            {this.props.roles.selectedGroup.map(role =>
                                                                role.GroupName === 'affiliate_lm-media-buys_report' ?
                                                                    <OffersSelect self={this} company="lm" role={role} />
                                                                    :
                                                                    <RoleSelect self={this} role={role} />
                                                            )}
                                                        </ul>
                                                    </>
                                                    :
                                                    this.props.roles.selectedGroupName === 'affiliate TA media buys' ?
                                                        <>
                                                            <h4 style={{ marginTop: 0, textTransform: 'capitalize' }}>
                                                                {this.props.roles.selectedGroupName}
                                                            </h4>
                                                            <ul>
                                                                {this.props.roles.selectedGroup.map(role =>
                                                                    role.GroupName === 'affiliate_ta-media-buys_report' ?
                                                                        <OffersSelect self={this} company="ta" role={role} />
                                                                        :
                                                                        <RoleSelect self={this} role={role} />
                                                                )}
                                                            </ul>
                                                        </>
                                                        :
                                                        this.props.roles.selectedGroupName === 'affiliate TG media buys' ?
                                                        <>
                                                            <h4 style={{ marginTop: 0, textTransform: 'capitalize' }}>
                                                                {this.props.roles.selectedGroupName}
                                                            </h4>
                                                            <ul>
                                                                {this.props.roles.selectedGroup.map(role =>
                                                                    role.GroupName === 'affiliate_tg-media-buys_report' ?
                                                                        <OffersSelect self={this} company="tg" role={role} />
                                                                        :
                                                                        <RoleSelect self={this} role={role} />
                                                                )}
                                                            </ul>
                                                        </>
                                                        :
                                                        <>
                                                            <h4 style={{ marginTop: 0, textTransform: 'capitalize' }}>
                                                                {this.props.roles.selectedGroupName}
                                            &nbsp;
                                            | Select: &nbsp;
                                            <span className="link" onClick={() => this.props.selectAllRolesInGroup(this.props.users.editedUser?.Username, this.props.roles.selectedGroup)}>All</span>&nbsp;/&nbsp;
                                            <span className="link" onClick={() => this.props.selectNoRolesInGroup(this.props.users.editedUser?.Username, this.props.roles.selectedGroup)}>None</span>
                                                            </h4>
                                                            <ul>
                                                                {this.props.roles.selectedGroup.map((role, i) => <RoleSelect key={'role-' + i} self={this} role={role} />
                                                                )}
                                                            </ul>
                                                        </>
                                            )}
                                        </div>
                                    </div>
                                    : null}
                            </section>
                        )}
                    </form>
                    : null}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateUserField: (field, value) => dispatch(updateUserField(field, value)),
        loadUsers: history => dispatch(loadUsers(history)),
        loadExternalUserById: id => dispatch(loadExternalUserById(id)),
        saveExternalUser: (user, history) => dispatch(saveExternalUser(user, history)),
        emptyUser: () => dispatch(emptyUser()),
        loadExternalRoles: () => dispatch(loadExternalRoles()),
        selectGroup: (group, name) => dispatch(selectGroup(group, name)),
        addRole: (username, role) => dispatch(addRole(username, role, 'external')),
        removeRole: (username, role) => dispatch(removeRole(username, role, 'external')),
        resetRoles: (username, roles) => dispatch(resetExternalRoles(username, roles)),
        selectAllRoles: roles => dispatch(selectAllRoles(roles)),
        selectNoRoles: roles => dispatch(selectNoRoles(roles)),
        selectAllRolesInGroup: (username, roles) => dispatch(selectAllRolesInGroup(username, roles, 'external')),
        selectNoRolesInGroup: (username, roles) => dispatch(selectNoRolesInGroup(username, roles, 'external')),
        resetPassword: email => dispatch(resetPassword(email, 'external')),
        loadOptions: (companies, account_type) => dispatch(loadOptions(companies, account_type))
    }
}

const mapStateToProps = (state: AppState) => ({
    users: state.users,
    roles: state.roles
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UserEditExternal)
);
